export enum ManagementPosition {
  projectManager = 'Project Manager',
  headOfDelivery = 'Head of Delivery',
  deliveryManager = 'Delivery Manager',
  deliveryManagerAssociate = 'Delivery Manager Associate',
}

export const managementPosition: string[] = Object.values(ManagementPosition);

export const managementDeliveryPosition: string[] = managementPosition.filter(
  el => el !== ManagementPosition.projectManager
);
